import { Outlet } from 'react-router-dom';

import useMediaQuery from '@mui/material/useMediaQuery';
import Toolbar from '@mui/material/Toolbar';
import Box from '@mui/material/Box';

import Drawer from './Drawer';
import Header from './Header';
import Footer from './Footer';
import Loader from 'components/Loader';
import Breadcrumbs from 'components/@extended/Breadcrumbs';
import { ChatProvider } from 'components/chat/ChatContext';
import ChatDrawer from 'components/chat/ChatDrawer';
import { ContextualHelpProvider } from 'contexts/ContextualHelpContext';
import { useShellConfig } from 'contexts/ShellConfigContext';
import { BreadcrumbProvider } from 'contexts/BreadcrumbContext';

import { useGetMenuMaster } from 'api/menu';

function ShellBanner() {
  const { Banner } = useShellConfig();
  return Banner ? <Banner /> : null;
}

function DashboardContent() {
  return (
    <Box
      component="main"
      sx={{
        flex: '1 1 0',
        minWidth: 0,
        p: { xs: 2, sm: 3 }
      }}
    >
      <Toolbar sx={{ mt: 'inherit' }} />
      <Box
        sx={{
          px: { xs: 0, sm: 2 },
          position: 'relative',
          minHeight: 'calc(100vh - 110px)',
          display: 'flex',
          flexDirection: 'column'
        }}
      >
        <Breadcrumbs />
        <ShellBanner />
        <Outlet />
        <Footer />
      </Box>
    </Box>
  );
}

function Workspace() {
  const downLG = useMediaQuery((theme) => theme.breakpoints.down('lg'));

  return (
    <Box
      sx={{
        display: 'flex',
        flex: '1 1 0',
        minWidth: 0,
        flexDirection: 'row'
      }}
    >
      <DashboardContent />
      <ChatDrawer overlay={downLG} />
    </Box>
  );
}

export default function DashboardLayout() {
  const { menuMasterLoading } = useGetMenuMaster();

  if (menuMasterLoading) return <Loader />;

  return (
    <BreadcrumbProvider>
      <ChatProvider>
        <ContextualHelpProvider>
          <Box sx={{ display: 'flex', width: '100%', minHeight: '100vh' }}>
            <Header />
            <Drawer />
            <Workspace />
          </Box>
        </ContextualHelpProvider>
      </ChatProvider>
    </BreadcrumbProvider>
  );
}
